/**
 * /frontend/src/features/analytics/components/customers/CustomerSegmentPieChart.js
 */

import React from 'react';
import ChartContainer from '../shared/ChartContainer';
import DistributionPieChart from '../charts/DistributionPieChart';

/**
 * Customer segments distribution pie.
 * @param {{data:Array<{name:string,value:number}>}} props
 * @returns {JSX.Element}
 */
const CustomerSegmentPieChart = ({ data }) => (
  <ChartContainer title="Customer Segments" subtitle="New vs returning vs at-risk">
    <DistributionPieChart data={data} nameKey="name" valueKey="value" />
  </ChartContainer>
);

export default CustomerSegmentPieChart;

